import { env } from "~/env";
import { Card } from "~/screens/Hub/Home/components";
import { customIcons } from "~/ui";

export const AccountInformation = () => (
  <Card title="Account information" className="items-start space-y-2">
    <div className="text-indigo w-full text-left">
      <p className="mb-4">Questions about your account or want to cancel?</p>

      <div className="flex items-center gap-1">
        <customIcons.Email className="text-violet" aria-hidden="true" />
        <span className="text-indigo">Email:</span>
        <a
          href={`mailto:${env.VITE_ELEKTRA_CARE_EMAIL}`}
          className="text-violet font-medium hover:underline"
        >
          {env.VITE_ELEKTRA_CARE_EMAIL}
        </a>
      </div>
    </div>
  </Card>
);
